import React from 'react';
import {useAppState} from "@nutastic/nutastic-react-app";
import LinksApp from "../linksPage/LinksApp";

const AppLinkSite = () => {
    const { linksAppConfig = {} } = useAppState();
    return <LinksApp {...linksAppConfig} />;
};

export default AppLinkSite;
